import React from 'react';

function Credits(props) {
  return (
    <div className="app__credits" dangerouslySetInnerHTML={{__html: props.strings}} />
  );
}

export default Credits;


/** WEBPACK FOOTER **
 ** ./src/components/Credits.js
 **/